import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../assets/logo.png";
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (path) => location.pathname === path;
  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      {" "}
      <div className="container mx-auto px-4 py-3">
        {" "}
        <div className="flex items-center justify-between">
          {" "}
          <div className="flex items-center space-x-3">
            {" "}
            <NavLink to={"/"}>
              <img
                src={logo}
                alt="Rishabh Enterprises Logo"
                className="h-12 md:h-16"
              />
            </NavLink>{" "}
            <div>
              {" "}
              <p className="text-xs text-neutral-600">
                Official SBI & IDFC FASTag Services
              </p>{" "}
            </div>{" "}
          </div>{" "}
          <nav className="hidden md:flex space-x-6">
            {" "}
            <Link
              to="/"
              className={`${isActive("/") ? "text-primary font-semibold" : "text-neutral-700"} hover:text-primary transition`}
            >
              {" "}
              Home{" "}
            </Link>{" "}
            <Link
              to="/about"
              className={`${isActive("/about") ? "text-primary font-semibold" : "text-neutral-700"} hover:text-primary transition`}
            >
              {" "}
              About Us{" "}
            </Link>{" "}
            <Link
              to="/services"
              className={`${isActive("/services") ? "text-primary font-semibold" : "text-neutral-700"} hover:text-primary transition`}
            >
              {" "}
              Services{" "}
            </Link>{" "}
            <Link
              to="/pricing"
              className={`${isActive("/pricing") ? "text-primary font-semibold" : "text-neutral-700"} hover:text-primary transition`}
            >
              {" "}
              Pricing{" "}
            </Link>{" "}
            <Link
              to="/contact"
              className={`${isActive("/contact") ? "text-primary font-semibold" : "text-neutral-700"} hover:text-primary transition`}
            >
              {" "}
              Contact{" "}
            </Link>{" "}
          </nav>{" "}
          <button
            className="md:hidden text-neutral-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {" "}
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {" "}
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}{" "}
            </svg>{" "}
          </button>{" "}
        </div>{" "}
        {isMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col space-y-3">
            {" "}
            <Link
              to="/"
              className={`${isActive("/") ? "text-primary font-semibold" : "text-neutral-700"} hover:text-primary transition`}
              onClick={() => setIsMenuOpen(false)}
            >
              {" "}
              Home{" "}
            </Link>{" "}
            <Link
              to="/about"
              className={`${isActive("/about") ? "text-primary font-semibold" : "text-neutral-700"} hover:text-primary transition`}
              onClick={() => setIsMenuOpen(false)}
            >
              {" "}
              About Us{" "}
            </Link>{" "}
            <Link
              to="/services"
              className={`${isActive("/services") ? "text-primary font-semibold" : "text-neutral-700"} hover:text-primary transition`}
              onClick={() => setIsMenuOpen(false)}
            >
              {" "}
              Services{" "}
            </Link>{" "}
            <Link
              to="/pricing"
              className={`${isActive("/pricing") ? "text-primary font-semibold" : "text-neutral-700"} hover:text-primary transition`}
              onClick={() => setIsMenuOpen(false)}
            >
              {" "}
              Pricing{" "}
            </Link>{" "}
            <Link
              to="/contact"
              className={`${isActive("/contact") ? "text-primary font-semibold" : "text-neutral-700"} hover:text-primary transition`}
              onClick={() => setIsMenuOpen(false)}
            >
              {" "}
              Contact{" "}
            </Link>{" "}
          </nav>
        )}{" "}
      </div>{" "}
    </header>
  );
};
export default Header;
